var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wrap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element",
    d: "M40.0085 0H-8.00391V31.9358H40.0085V0Z",
    fill: "#B31942"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Element_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-8.00391 3.68475H40.0085H-8.00391ZM40.0085 8.59795H-8.00391H40.0085ZM-8.00391 13.5112H40.0085H-8.00391ZM40.0085 18.4244H-8.00391H40.0085ZM-8.00391 23.3375H40.0085H-8.00391ZM40.0085 28.2507H-8.00391H40.0085Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.00391 3.68475H40.0085M40.0085 8.59795H-8.00391M-8.00391 13.5112H40.0085M40.0085 18.4244H-8.00391M-8.00391 23.3375H40.0085M40.0085 28.2507H-8.00391",
    stroke: "white",
    strokeWidth: 2.4566
  })), /*#__PURE__*/React.createElement("path", {
    id: "Element_3",
    d: "M16.2674 0H-8.00391V17.1962H16.2674V0Z",
    fill: "#0A3161"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Element_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_8",
    d: "M0.087136 2.45737L0.664719 4.23498L-0.847412 3.13635H1.02168L-0.490446 4.23498L0.087136 2.45737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_9",
    d: "M0.0870597 5.89694L0.664642 7.67455L-0.847488 6.57593H1.02161L-0.490523 7.67455L0.0870597 5.89694Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_10",
    d: "M0.0870597 9.33621L0.664642 11.1138L-0.847488 10.0152H1.02161L-0.490523 11.1138L0.0870597 9.33621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_11",
    d: "M0.0870597 12.7747L0.664642 14.5524L-0.847488 13.4537H1.02161L-0.490523 14.5524L0.0870597 12.7747Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Element_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_16",
    d: "M2.10911 0.736511L2.68669 2.51412L1.17456 1.4155H3.04366L1.53153 2.51412L2.10911 0.736511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_17",
    d: "M2.10903 4.17586L2.68661 5.95347L1.17448 4.85484H3.04358L1.53145 5.95347L2.10903 4.17586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_18",
    d: "M2.1094 7.61641L2.68698 9.39402L1.17485 8.2954H3.04395L1.53182 9.39402L2.1094 7.61641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_19",
    d: "M2.10903 11.0544L2.68661 12.832L1.17448 11.7334H3.04358L1.53145 12.832L2.10903 11.0544Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Element_20",
    d: "M2.1094 14.4939L2.68698 16.2715L1.17485 15.1728H3.04395L1.53182 16.2715L2.1094 14.4939Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_22",
    d: "M4.1321 2.45663L4.70969 4.23425L3.19756 3.13562H5.06665L3.55452 4.23425L4.1321 2.45663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_23",
    d: "M4.1322 5.89557L4.70978 7.67318L3.19765 6.57456H5.06674L3.55461 7.67318L4.1322 5.89557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_24",
    d: "M4.13236 9.33548L4.70995 11.1131L3.19781 10.0145H5.06691L3.55478 11.1131L4.13236 9.33548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_25",
    d: "M4.1322 12.7739L4.70978 14.5515L3.19765 13.4529H5.06674L3.55461 14.5515L4.1322 12.7739Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Element_26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_29",
    d: "M6.15443 0.736481L6.73201 2.51409L5.21988 1.41547H7.08898L5.57684 2.51409L6.15443 0.736481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_30",
    d: "M6.15405 4.17656L6.73163 5.95417L5.2195 4.85555H7.08859L5.57646 5.95417L6.15405 4.17656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_31",
    d: "M6.15405 7.6172L6.73163 9.39481L5.2195 8.29619H7.08859L5.57646 9.39481L6.15405 7.6172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_32",
    d: "M6.15435 11.0538L6.73193 12.8314L5.2198 11.7328H7.0889L5.57677 12.8314L6.15435 11.0538Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Element_33",
    d: "M6.15441 14.4946L6.73199 16.2723L5.21986 15.1736H7.08896L5.57683 16.2723L6.15441 14.4946Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_35",
    d: "M8.17799 2.45587L8.75557 4.23348L7.24344 3.13486H9.11253L7.6004 4.23348L8.17799 2.45587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_36",
    d: "M8.17791 5.89618L8.75549 7.67379L7.24336 6.57517H9.11246L7.60033 7.67379L8.17791 5.89618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_37",
    d: "M8.17802 9.33435L8.7556 11.112L7.24347 10.0133H9.11257L7.60043 11.112L8.17802 9.33435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_38",
    d: "M8.17791 12.7745L8.75549 14.5521L7.24336 13.4535H9.11246L7.60033 14.5521L8.17791 12.7745Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Element_39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_42",
    d: "M10.2001 0.73642L10.7777 2.51403L9.26559 1.41541H11.1347L9.62256 2.51403L10.2001 0.73642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_43",
    d: "M10.2002 4.17662L10.7778 5.95423L9.26567 4.85561H11.1348L9.62264 5.95423L10.2002 4.17662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_44",
    d: "M10.2001 7.61488L10.7777 9.3925L9.26559 8.29387H11.1347L9.62256 9.3925L10.2001 7.61488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_45",
    d: "M10.2006 11.0563L10.7782 12.8339L9.26604 11.7352H11.1351L9.623 12.8339L10.2006 11.0563Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Element_46",
    d: "M10.201 14.4939L10.7785 16.2715L9.2664 15.1729H11.1355L9.62337 16.2715L10.201 14.4939Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Element_47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_48",
    d: "M12.2229 2.45813L12.8005 4.23574L11.2884 3.13712H13.1575L11.6453 4.23574L12.2229 2.45813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_49",
    d: "M12.2227 5.89825L12.8003 7.67587L11.2881 6.57724H13.1572L11.6451 7.67587L12.2227 5.89825Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_50",
    d: "M12.223 9.3367L12.8005 11.1143L11.2884 10.0157H13.1575L11.6454 11.1143L12.223 9.3367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_51",
    d: "M12.223 12.7769L12.8006 14.5545L11.2885 13.4559H13.1576L11.6455 14.5545L12.223 12.7769Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Element_52"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_54",
    d: "M14.2447 0.737396L14.8223 2.51501L13.3101 1.41638H15.1792L13.6671 2.51501L14.2447 0.737396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_55",
    d: "M14.245 4.17613L14.8226 5.95374L13.3105 4.85512H15.1796L13.6674 5.95374L14.245 4.17613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_56",
    d: "M14.2448 7.61687L14.8223 9.39448L13.3102 8.29585H15.1793L13.6672 9.39448L14.2448 7.61687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_57",
    d: "M14.245 11.0548L14.8226 12.8324L13.3104 11.7338H15.1795L13.6674 12.8324L14.245 11.0548Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Element_58",
    d: "M14.2449 14.4953L14.8224 16.273L13.3103 15.1743H15.1794L13.6673 16.273L14.2449 14.4953Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsa);
export default __webpack_public_path__ + "static/media/USA.b48ef29ee9ee90ca0cb0ea12ddec91f9.svg";
export { ForwardRef as ReactComponent };